export const PAGE_NAVIGATE = 'PAGE_NAVIGATE';

export const navigatePage = () => ({
  type: PAGE_NAVIGATE
});


// WEBPACK FOOTER //
// ./src/page/actions.js